<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <Loading v-if="loading"/>
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
           
        </section>
        <Edit :task="selectedTask" ref = "settings"  @changeError="changeError($event)" @changeMsg="changeMsg($event)"/>
        <Create ref = "create"  @changeError="changeError($event)" @changeMsg="changeMsg($event)"/>
        <Delete :task="selectedTask"  ref = "remove"   @changeError="changeError($event)" @changeMsg="changeMsg($event)"/>
        <section class="section section-lg pt-lg-0 mt--400">
             
            <div class="container card card-profile shadow p-3 ">

                <div class="row justify-content-center mb-5">
                    <div class="col-lg-3 order-lg-2">
                        <div class="card-profile-image">
                            <a href="#">
                                <img v-lazy="'img/list.png'" class="rounded-circle bg-white">
                            </a>
                        </div>
                        
                    </div>
                    <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
                        <div class="card-profile-actions py-4 mt-lg-0">
                            <base-button @click="createTask" type="primary" icon="fa fa-plus"></base-button>
                        </div>
                    </div>
                    <div class="col-lg-4 order-lg-1">
                        <div class="card-profile-stats d-flex justify-content-center">
                            <h2 class="col-11 text-center font-weight-bold">TASKS</h2>                                
                        </div>
                    </div>
                </div>
               
                <div class="row justify-content-center mt-3">
                     
                    <div class="col-lg-10">
                           <base-alert v-if="error || msg" :type=" error ? 'danger':'primary'">
                                <span class="alert-inner--icon"><i :class="error ? '':'ni ni-like-2'"></i></span>
                                <span class="alert-inner--text"><strong>{{ error ? 'Error ! ' : 'Success ! '}}</strong> {{ error ? error : msg }}</span>
                            </base-alert>
                        <div class="row">
                            <div class="col-6 mb-5"  v-for="task in tasks" :key="task.TaskID">
                         
                                <card class="border-0 " hover shadow body-classes="py-3">
                                   <icon name="ni ni-bullet-list-67" type="primary" rounded class="mb-4">
                                    </icon>
                                    <div class="p-3">
                                        <h6 class="text-primary text-uppercase">{{ task.TaskName }}</h6>
                                        <p class="description mt-3">Recommended time for this task is {{ task.RecommendedTime[0].Time.substring(0,5) }}</p>
                                        
                                    </div> 

                                    <div class="row m-3">
                                        <base-button type="primary"  icon="fa fa-pencil" class="col" @click="editTask(task)" >EDIT</base-button>
                                        <base-button type="danger"  icon="fa fa-trash-o" class="col" @click="removeTask(task)">DELETE</base-button>
                                    </div>                                    
                                </card>
                            </div>
                        
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
    </div>
</template>
<script>
import Loading from './Loading'
import Edit from "../views/components/Tasks/Edit"
import Create from "../views/components/Tasks/Add"
import Delete from "../views/components/Tasks/Delete"
import moment from "moment"
import _ from "lodash"


export default {
     components: { 
         Loading,
         Edit,
         Create,
         Delete,
        
     },
     data(){
         return{
             loading:false,
             error:'',
             msg:'',
             show:false,
             selectedTask:{},
            
        
         }
     },
     computed:{
         tasks(){
             return this.$store.state.tasks
         },
   
    },
   
     methods:{
           editTask(task){
             this.selectedTask = task
             this.$refs.settings.handleShow()
           },

           removeTask(task){
               this.selectedTask = task
               this.$refs.remove.handleShow()
           },

           createTask(){                   
               this.$refs.create.handleShow()
           },

           changeError (error) {
                this.error = error;
                 window.scroll({
                        top: 0, 
                        left: 0, 
                        behavior: 'smooth'
                    });

                setTimeout(() => {
                    this.error = ''
                   
                }, 5000);

            },
            changeMsg (msg) {
                this.msg = msg;
                window.scroll({
                        top: 0,  
                        left: 0, 
                        behavior: 'smooth'
                    });
                setTimeout(() => {
                    this.msg = ''
                   
                }, 5000);
            }

     }

};
</script>
<style>
</style>
